module.exports = __webpack_public_path__ + "img/icon.56a95a66.png";